import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { GroupsService } from '../../services/groups.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/mergeMap';
import { ToasterService } from 'angular2-toaster';

declare function confirm(message?: string);

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit {
  public users: Array<any> = [];
  public groups: Array<any> = [];
  public groupConfig: any = {
    paging: true,
    sorting: {columns: this.groups},
    filtering: {filterString: ''}
  };
  public groupColumns: Array<any> = [
    {title: 'Name', name: 'name'},
    {title: 'Created At', name: 'created_at'}
  ];
  user = {};
  groupName = '';
  constructor(
    private usersService: UsersService,
    private groupsService: GroupsService,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
    Observable.forkJoin(
      this.usersService.getAll(),
      this.groupsService.getAll()
    ).subscribe(([users, groups]) => {
      // Map groups to users
      users.forEach(user => {
        user.group = groups.find(group => {
          return group.id === user.group_id;
        });
        user.group = user.group || {};
      });
      this.users = users;
      this.groups = groups;
    });
  }

  deleteUser(userId: number) {

    /* tslint:disable:prefer-const */
    let confirmation = confirm('Are you sure?');

    if (confirmation) {
      this.usersService.delete(userId).subscribe(() => {
        this.toasterService.pop('success', 'Success', 'User deleted');
        this.users = this.users.filter((user) => user.id !== userId);
      }, error => {
        this.toasterService.pop('error', 'Error', error);
      });
    }
  }

  addGroup(groupName) {
    this.groupsService.save(groupName).subscribe(savedGroup => {
      this.groups.push(savedGroup);
      this.toasterService.pop('success', 'Success', 'Group added');
      this.groupName = "";
    });
  }

  deleteGroup(groupId: number) {
    /* tslint:disable:prefer-const */
    let confirmation = confirm('Are you sure?');
    if (confirmation) {
      this.groupsService.delete(groupId).subscribe(() => {
        this.toasterService.pop('success', 'Success', 'Group deleted');
        this.groups = this.groups.filter((group) => group.id !== groupId);
      }, error => {
        this.toasterService.pop('error', 'Error', error);
      });
    }
  }

  addUser(user) {
    this.usersService.save(user).flatMap(() => {
      return this.usersService.getAll();
    }).subscribe(users => {
      // Map groups to users
      users.forEach(user => {
        user.group = this.groups.find(group => {
          return group.id === user.group_id;
        });
        user.group = !!user.group ? user.group.name : '';
      });
      this.users = users;
      this.toasterService.pop('success', 'Success', 'User added');
      this._resetForm();
    }, error => {
      this.toasterService.pop('error', 'Error', error);
    });
  }

  saveUser(user) {
    delete user.editing;

    this.usersService.update(user).subscribe(() => {
      delete user.password;
      this.toasterService.pop('success', 'Success', 'User updated');
    });
  }

  toggleEditUser(user) {
    user.editing = !user.editing;
  }

  private _resetForm() {
    this.user = {};
  }

}



// WEBPACK FOOTER //
// ./src/app/components/users/users.component.ts